/**
 * 메인 페이지 탭 타입을 정의하는 enum
 */
export enum ManualTabType {
  REVIEW = 'review',
  FAQ = 'faq',
}
